import { Grid, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import FormTextBox from '../../../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox';
//@ts-ignore
import { IFieldFormChild } from '../../../yoello-lib/modules/dynamicForms/interfaces/IFieldFormChild';
import DeleteIcon from '@material-ui/icons/Delete';


export function PreferenceEntity(props: IFieldFormChild) {
    const { t } = useTranslation();
    const key = `${props.keyName}.${props.index}.preference_name`;
    const newProps = {
        ...props,
        errors: props.errors && (Array.isArray(props.errors) ? props.errors[props.index] : props.errors)
    }
    return <>
        <Grid item xs={11} style={{ margin: "0 -6px" }}>
            <FormTextBox {...newProps} keyName={key} value={undefined}
                data-component-name="PREFERENCE_ITEM" label={t('preferences.name')} />
        </Grid>
        <Grid item xs={1} style={{ display: "flex", alignItems: "end" }}>
            {props.onDelete ?
                <IconButton onClick={props.onDelete} aria-label="delete" color="secondary" data-component-name="PREFERENCE_DELETE">
                    <DeleteIcon />
                </IconButton> : null}
        </Grid>
    </>
}